
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputComponent from '../InputComponent';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';

import DropDownList from '../DropDownList';

import { getUIText, generateUid, getUniqueName } from '../../utils/index';

import { CLADDING } from '../../modules/data/claddings';

const defaultItem = {
  'custom': 'true',
  'name': '',
  'Emissivity': 1,
  'MST': 1,
};

class Cladding extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: null,
    };
  }

  onCreateNewItem() {
    const { translations, app, create, items} = this.props;

    const newItem = {
      ...defaultItem,
      name: getUniqueName(items, getUIText('SETTINGS-CUSTOM_CLADDING_HEADER', app.language, translations)),
      Nid: generateUid()
    };

    this.setState({
      id: newItem.Nid
    });

    create({item: newItem, type: CLADDING});
  }

  onDeleteItem(id, e) {
    const { items, remove } = this.props;
    if(items) {
      const index = items.findIndex( (item ) => {
        if(item.Nid === id) {
          return true;
        }
        return false;
      });

      const newItems = [
        ...items.slice(0, index),
        ...items.slice(index + 1)
      ];

      let newId = '-1';
      if(newItems[index]) {
        newId = newItems[index].Nid;
      } else if (newItems[index - 1]) {
        newId = newItems[index - 1].Nid;
      }

      remove({id: items[index].Nid, type: CLADDING});
      this.setState({
        id: newId
      });
    }
  }

  onPatchItem(id, updateItem, e) {
    const { items, patch } = this.props;

    if(items) {
      const updatedItem = items.find( item => {
        if(item.id === id) {
          return true;
        }
        return false;
      });
      patch({item: updateItem, type: CLADDING});
    }
  }

  render() {
    const { translations, app, items} = this.props;

    let data = [];
    if(items) {
      data = items.filter( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return true;
        }
      });
    }

    data = data.map( item => {
      return {...item, id: item.Nid};
    });

    const selectedItem = data.find( (item) => {
      if(item.Nid === this.state.id) {
        return true;
      }
      return false;
    });

    return (
      <div className="settings-product">
        <Grid container spacing={8}>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <DropDownList
              data={data}
              selectedItem={this.state.id}
              label={getUIText('SETTINGS-CUSTOM_CLADDINGS', app.language, translations)}
              onChange={ (id) => {this.setState({id: id});} } />
          </Grid>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <div className="settings-buttons" >
              <Button color="primary" onClick={this.onCreateNewItem.bind(this)} >{getUIText('GENERAL-NEW', app.language, translations)}</Button>
              <Button color="primary" disabled={this.state.id ? false : true} onClick={this.onDeleteItem.bind(this, this.state.id)} >{getUIText('GENERAL-DELETE', app.language, translations)}</Button>
            </div>
          </Grid>
          {selectedItem ? <Grid item xs={12} md={6}>
            <InputComponent
              label={getUIText('SETTINGS-PRODUCT_NAME', app.language, translations)}
              value={selectedItem ? selectedItem['name'] : ''}
              type="string"
              className="full-width settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'name': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-EMISSITY', app.language, translations)}
              value={selectedItem ? selectedItem['Emissivity'] : ''}
              type="number"
              className="settings-margin"
              unit="ε"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Emissivity': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-MST', app.language, translations)}
              value={selectedItem ? selectedItem['MST'] : ''}
              type="number"
              className="settings-margin"
              unit="°C"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'MST': value})}
              />
          </Grid> : null }
        </Grid>
      </div>
    );
  }
}

Cladding.propTypes = {

  translations: PropTypes.any,
  app: PropTypes.any,
  create: PropTypes.any,
  items: PropTypes.any,
  remove: PropTypes.any,
  patch: PropTypes.any,
};

export default Cladding;
